module.exports = Promise.all([__parcel__import__("2C5F6"), __parcel__import__("GcsqM")]).then(() => parcelRequire('g36Vt'));